module.exports = __webpack_public_path__ + "static/img/top-img1.8d16c35.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/top-img1.png
// module id = sQ0V
// module chunks = 0